import React from 'react';

const NotFound = () => {
    return (
        <div style={{display:"flex", justifyContent:"center",alignItems:"center", minHeight:"100vh",margin:0}}>
            <h2>404 Not found</h2>
        </div>
    );
};

export default NotFound;